import { useEffect, useState } from 'react';
import OInput from '../../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
import styles from '../../index.module.css';
import DoneIcon from '@mui/icons-material/Done';

const INITIAL_VALUES = {
  sifra: '',
};

const SearchForm = ({
  setMasineData,
  masineData,
  filterMasine,
  setFilterMasine,
  responseTipMasina,
  filterValues,
  setFilterValues,
  selectedFilters,
  setSelectedFilters,
}) => {
  const { t, i18n } = useTranslation();
  // const [filterValues, setFilterValues] = useState(INITIAL_VALUES);
  // const [selectedFilters, setSelectedFilters] = useState([]);

  useEffect(() => {
    let filterList = masineData.source;
    console.log('ovo je filterMasine', masineData);

    if (selectedFilters.length > 0) {
      filterList = filterList.filter((masina) =>
        selectedFilters.includes(masina.tipMasine),
      );
    }

    filterList = filterList.filter((item) =>
      item?.pretraga?.toLowerCase().includes(filterValues.sifra.toLowerCase()),
    );
    console.log('ovo je filterList', filterList);
    const uniqueTipMasine = new Set(filterList.map((item) => item.tipMasine));

    // Dobijanje broja različitih tipova mašina
    const brojRazlicitihTipovaMasina = uniqueTipMasine.size;

    console.log('Broj različitih tipova mašina:', brojRazlicitihTipovaMasina);
    setMasineData((curr) => ({
      ...curr,
      filtered: filterList,
    }));
  }, [filterValues, selectedFilters, masineData.source]);

  const handleChange = (e) => {
    setFilterValues((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };

  const handleClickFilter = (e, item) => {
    setSelectedFilters((curr) => {
      if (curr.includes(item.vrednost)) {
        return curr.filter((filter) => filter !== item.vrednost);
      }
      return [...curr, item.vrednost];
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '5px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {filterMasine.length > 1 &&
        filterMasine.map((item, index) => {
          if (responseTipMasina.length > 1) {
            return (
              <div
                key={index}
                className={`${styles.filterBtn} ${
                  selectedFilters.includes(item.vrednost)
                    ? styles.selectedFilterBtn
                    : ''
                }`}
                onClick={(e) => handleClickFilter(e, item)}
              >
                {selectedFilters.includes(item.vrednost) && (
                  <DoneIcon style={{ color: '#ff7c00', marginRight: '5px' }} />
                )}
                {item.vrednost === 'Robot' ? t('Robot') : t('Alat')}
              </div>
            );
          }
          return null;
        })}
      <OInput
        label={`${t('search')} `}
        name="sifra"
        value={filterValues.sifra}
        handleChange={handleChange}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default SearchForm;
